var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M36.0492 4.41316C35.6505 2.82278 34.4166 1.58426 32.8263 1.19018C30.002 0.392645 18.6536 0.392639 18.6536 0.392639C18.6536 0.392639 7.30983 0.392645 4.48092 1.19018C2.89055 1.58426 1.69894 2.82278 1.25795 4.41316C0.507327 7.23737 0.507324 13.2001 0.507324 13.2001C0.507324 13.2001 0.507327 19.1629 1.25795 21.9871C1.69894 23.5774 2.89055 24.8113 4.48092 25.2523C7.30514 26.0029 18.6536 26.0029 18.6536 26.0029C18.6536 26.0029 30.002 26.0029 32.8263 25.2523C34.4166 24.8113 35.6505 23.5728 36.0492 21.9871C36.7999 19.1629 36.7999 13.2001 36.7999 13.2001C36.7999 13.2001 36.7999 7.23737 36.0492 4.41316ZM14.9474 18.5905V7.81441L24.4381 13.2048L14.9474 18.5905Z","fill":"white"}));
}

Youtube.defaultProps = {"width":"37","height":"27","viewBox":"0 0 37 27","fill":"none"};

module.exports = Youtube;

Youtube.default = Youtube;
